import { axiosGetHandler, axiosPostHandler } from '../config';
import axios from '_lib/encrypt/axios';
import { getUrlParam, getCookie, getSmDeviceId } from '_lib/utils';

const BASE_URL =
  window.location.host.indexOf('debugmode.cn') >= 0 || IS_TEST
    ? 'https://heybox.debugmode.cn'
    : 'https://api.xiaoheihe.cn';

axios.defaults.withCredentials = true;
axios.interceptors.request.handlers.unshift({
  fulfilled: async (config) => {
    const branch = getUrlParam('branch');
    if (branch) {
      config.params.branch = branch;
    }
    const heybox_id = getCookie('heybox_id') || getCookie('user_heybox_id');
    if (heybox_id) {
      config.params.heybox_id = heybox_id;
    }
    const pkey = getCookie('user_pkey') || getCookie('pkey');
    if (pkey) {
      config.params.pkey = pkey;
    }
    config.url = BASE_URL + config.url;

    let device_id = getCookie('x_xhh_tokenid');
    if (!device_id) {
      device_id = await getSmDeviceId();
    }

    return config;
  },
  rejected: null,
});

export function codeLogin(args, formdata) {
  let url = '/account/login_code/';
  return axiosPostHandler(url, args, formdata);
}

// 发送验证码
export function sendCode(args, formdata) {
  let url = '/account/get_login_code/';
  return axiosPostHandler(url, args, formdata);
}

export function getLoginQrCodeState(args) {
  let url = '/account/qr_state/';
  return axiosGetHandler(url, args);
}

export function getPermission(args) {
  let url = '/bbs/app/api/user/permission';
  return axiosGetHandler(url, args);
}

export function getLoginQrCode(args) {
  let url = '/account/get_qrcode_url/';
  return axiosGetHandler(url, args);
}

export function googleVertify(args) {
  let url = '/account/google_2fa_verify/';
  return axiosGetHandler(url, args);
}

export function wechatLogin(args) {
  let url = '/account/wechat/state/';
  return axiosGetHandler(url, args);
}

export function pwdLogin(args, formdata) {
  let url = '/account/login/';
  return axiosPostHandler(url, args, formdata);
}
